import { render, staticRenderFns } from "./CompanySettingsPage.vue?vue&type=template&id=86ca7da0"
import script from "./CompanySettingsPage.vue?vue&type=script&lang=js"
export * from "./CompanySettingsPage.vue?vue&type=script&lang=js"
import style0 from "./CompanySettingsPage.vue?vue&type=style&index=0&id=86ca7da0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports